/**
 * 価格文字列を安全に整形する。
 *
 * データ側の価格は '220,000' や '330,000〜594,000'、'165,000〜' のように
 * カンマ区切り・範囲・接尾辞を含む文字列で保持されている。これを
 * `Number('220,000')` すると NaN になり「¥NaN」表示バグの原因になる。
 *
 * 先頭の数値部分（数字・カンマ・小数点）だけを取り出して桁区切り整形し、
 * それ以降の接尾辞（'〜594,000' や '〜' 等）はそのまま温存する。
 * 数値として解釈できない場合は元の文字列をそのまま返す。
 */
export function formatPrice(value: string | number | null | undefined): string {
  const str = String(value ?? '').trim();
  if (str === '') return '';
  const match = str.match(/^([\d,.]+)(.*)$/);
  if (!match) return str;
  const num = Number(match[1].replace(/,/g, ''));
  if (!Number.isFinite(num)) return str;
  return num.toLocaleString() + match[2];
}
